/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 16:08:27
 *
 *******************************************************/
// @flow
import type { Action } from './store.type';
import type { DefaultThemeSettingsType } from 'src/models/default-theme-settings';

export const GET_DEFAULT_THEME_SETTINGS_REQUEST = 'GET_DEFAULT_THEME_SETTINGS_REQUEST';
type GET_DEFAULT_THEME_SETTINGS_REQUEST_TYPE = 'GET_DEFAULT_THEME_SETTINGS_REQUEST';

export const GET_DEFAULT_THEME_SETTINGS_SUCCESS = 'GET_DEFAULT_THEME_SETTINGS_SUCCESS';
type GET_DEFAULT_THEME_SETTINGS_SUCCESS_TYPE = 'GET_DEFAULT_THEME_SETTINGS_SUCCESS';

export const GET_DEFAULT_THEME_SETTINGS_FAILURE = 'GET_DEFAULT_THEME_SETTINGS_FAILURE';
type GET_DEFAULT_THEME_SETTINGS_FAILURE_TYPE = 'GET_DEFAULT_THEME_SETTINGS_FAILURE';

export const UPDATE_DEFAULT_THEME_SETTINGS_REQUEST = 'UPDATE_DEFAULT_THEME_SETTINGS_REQUEST';
type UPDATE_DEFAULT_THEME_SETTINGS_REQUEST_TYPE = 'UPDATE_DEFAULT_THEME_SETTINGS_REQUEST';

export const UPDATE_DEFAULT_THEME_SETTINGS_SUCCESS = 'UPDATE_DEFAULT_THEME_SETTINGS_SUCCESS';
type UPDATE_DEFAULT_THEME_SETTINGS_SUCCESS_TYPE = 'UPDATE_DEFAULT_THEME_SETTINGS_SUCCESS';

export const UPDATE_DEFAULT_THEME_SETTINGS_FAILURE = 'UPDATE_DEFAULT_THEME_SETTINGS_FAILURE';
type UPDATE_DEFAULT_THEME_SETTINGS_FAILURE_TYPE = 'UPDATE_DEFAULT_THEME_SETTINGS_FAILURE';

type DefaultThemeSettingsSuccess = {
  data: DefaultThemeSettingsType
};

type DefaultThemeSettingsFailure = {
  error: any
};

type GetDefaultThemeSettingsRequestAction = Action<GET_DEFAULT_THEME_SETTINGS_REQUEST_TYPE, null>;

type GetDefaultThemeSettingsSuccessAction = Action<
  GET_DEFAULT_THEME_SETTINGS_SUCCESS_TYPE,
  DefaultThemeSettingsSuccess
>;

type GetDefaultThemeSettingsFailureAction = Action<
  GET_DEFAULT_THEME_SETTINGS_FAILURE_TYPE,
  DefaultThemeSettingsFailure
>;

type UpdateDefaultThemeSettingsRequestAction = Action<
  UPDATE_DEFAULT_THEME_SETTINGS_REQUEST_TYPE,
  null
>;

type UpdateDefaultThemeSettingsSuccessAction = Action<
  UPDATE_DEFAULT_THEME_SETTINGS_SUCCESS_TYPE,
  DefaultThemeSettingsSuccess
>;

type UpdateDefaultThemeSettingsFailureAction = Action<
  UPDATE_DEFAULT_THEME_SETTINGS_FAILURE_TYPE,
  DefaultThemeSettingsFailure
>;

export type DefaultThemeSettingsAction =
  | GetDefaultThemeSettingsRequestAction
  | GetDefaultThemeSettingsSuccessAction
  | GetDefaultThemeSettingsFailureAction
  | UpdateDefaultThemeSettingsRequestAction
  | UpdateDefaultThemeSettingsSuccessAction
  | UpdateDefaultThemeSettingsFailureAction;

export type DefaultThemeSettingsState = {
  loadingDefaultThemeSettings: boolean,
  savingDefaultThemeSettings: boolean,
  success: boolean,
  error: any,
  defaultThemeSettings: DefaultThemeSettingsType | {}
};
